var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNubeGrandeDerechaNaranjaBirdybuyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 548,
    height: 136,
    viewBox: "0 0 548 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M569 135.988H154.067C139.746 135.988 128.141 124.444 128.141 110.199C128.141 95.9538 139.746 84.4098 154.067 84.4098H246.024C252.94 84.4098 258.557 78.8341 258.557 71.9423C258.557 65.0621 252.952 59.4748 246.024 59.4748H29.8942C13.3805 59.4748 0 46.153 0 29.7374C0 13.3102 13.3921 0 29.8942 0H569V136V135.988Z",
    fill: "#FFD2B0",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNubeGrandeDerechaNaranjaBirdybuyer);
export default __webpack_public_path__ + "static/media/nube-grande-derecha-naranja-birdybuyer.a69e1c9f44f797733fbf6539b99e54b3.svg";
export { ForwardRef as ReactComponent };